// src/utils/oatt-invoice-generator/customerConfig.ts

export interface OattCustomerConfig {
    sectionHeading: string;  // bold underlined heading below header
}

const DEFAULT_CONFIG: OattCustomerConfig = {
    sectionHeading: '',      // filled dynamically with customer_code
};

const CONFIGS: Record<string, Partial<OattCustomerConfig>> = {
    test_customer2: {
        sectionHeading: 'test_customer2 OATT Reservations',
    },
    // Add more customers here as needed
};

export const getCustomerConfig = (
    customerCode: string,
): OattCustomerConfig => ({
    ...DEFAULT_CONFIG,
    sectionHeading: `${customerCode} Exports`,
    ...CONFIGS[customerCode],
});